import * as React from 'react';

import { Button } from 'components/elements';
import { Eye, Sei } from 'components/icons';
import { useTranslationX } from 'i18n';
import { useHistory } from 'react-router-dom';
import { useRequest } from 'apis';
import { Modal, ModalPDFViewer } from 'components/containers';
import { messageService } from 'services';

import styles from './AlterationPT.module.scss';

type AdditiveActionsProps = {
  projectId: string;
  granted: boolean;
};

const AdditiveActions = ({ projectId, granted }: AdditiveActionsProps) => {
  const [pdfData, setPdfData] = React.useState<string | ArrayBuffer | null>();
  const request = useRequest();

  const history = useHistory();
  const { tx: t1 } = useTranslationX('homologacao', 'supervisor');

  const getPdf = React.useCallback(() => {
    const source = request({
      url: `/projeto/${projectId}/alteracao-pt/pdf-description`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      responseType: 'blob',
      onSuccess: (blob: any) => {
        let reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = function () {
          let base64data = reader.result;
          setPdfData(base64data);
        };
      },
      onError: () => null,
    });

    return () => source.cancel();
  }, [projectId, request]);

  function closeModal() {
    setPdfData(undefined);
  }

  function copyHtml() {
    const source = request({
      url: `/projeto/${projectId}/alteracao-pt/html`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      responseType: 'text',
      onSuccess: async (text: any) => {
        await navigator.clipboard.writeText(text);
        messageService.success(t1('button.project.success-copied-message'), {
          duration: 3000,
        });
      },
      onError: () => {
        messageService.error(t1('button.project.error-copied-message'), {
          duration: 3000,
        });
      },
    });
    return () => source.cancel();
  }

  return (
    <>
      <Button
        theme="light"
        icon={Eye}
        type={granted ? undefined : 'disabled'}
        onClick={() => history.push(`/dashboard/projetos/${projectId}/aditivo`)}
      >
        {t1(`button.project.additive-pt`)}
      </Button>
      <Button theme="light" icon={Eye} onClick={getPdf}>
        {t1(`button.project.showPdf`)}
      </Button>
      <Button theme="light" icon={Sei} onClick={copyHtml}>
        {t1(`button.project.copyHtml`)}
      </Button>
      <Modal visible={pdfData !== undefined} width="auto" onBlur={closeModal}>
        <div className={styles.popup}>
          <ModalPDFViewer
            pdfData={pdfData}
            title={t1('button.project.wp')}
            onClose={closeModal}
          />
        </div>
      </Modal>
    </>
  );
};

export default AdditiveActions;
